import React from 'react';
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom';
import _ from '../../shared/utils/ObjectUtils';

class AuthenticationRoute extends React.Component {
    render() {
        const { 
            userLoggedIn, 
            children,
            loginError
        } = this.props;

        if (_.isNilOrEmpty(loginError) && userLoggedIn) {
            return children;
        } else {
            return <Redirect to="/auth" />
        }
    }
}

const mapStateToProps = ({ authReducer }) => {
    return ({
        userLoggedIn: authReducer.userLoggedIn,
        loginError: authReducer.loginError
    })
};

export default connect(
    mapStateToProps,
    null
)(AuthenticationRoute);